// Mask for Australian mobile numbers: "+61" is fixed in the field, the user fills the 9 national
// digits, unfilled positions show "_":   +61 4__ ___ ___  →  +61 412 345 678
// The backend (PhoneNumberService) stores E.164 (+61412345678) and accepts the spaced value as is.
export const PHONE_HINT = 'Please enter the phone in a similar format +614 **** **** without spaces'
export const PHONE_PREFIX = '+61 '
export const PHONE_DIGITS = 9
export const PHONE_MASK_LENGTH = PHONE_PREFIX.length + PHONE_DIGITS + 2 // two group separators

const groupDigits = digits => [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9)]

// Non-AU numbers (e.g. legacy "+7…") are not masked — the field falls back to plain text for them
export const isForeignPhone = value => /^\s*\+\s*(?!6\s*1)/.test(String(value == null ? '' : value))

// National digits out of anything the user can type, paste, or the DB can hold
// (+61 412…, 0412…, 61412…, +610412…, partially deleted prefix "+6 412…").
export function nationalDigits(raw) {
  let str = String(raw == null ? '' : raw)
  if (/^\s*\+/.test(str)) {
    str = str.replace(/^\s*\+\s*6?\s*1?/, '')
  }
  let digits = str.replace(/\D/g, '')
  // National AU numbers never start with 61, so any leftover country code is stripped. Needed when
  // the browser (Ctrl+Z, paste into the middle) leaves a second "+61 …" inside the mask.
  while (digits.startsWith('61')) {
    digits = digits.slice(2)
  }
  return digits.replace(/^0+/, '').slice(0, PHONE_DIGITS)
}

export function applyMask(digits) {
  const [a, b, c] = groupDigits(digits).map(part => part.padEnd(3, '_'))
  return `${PHONE_PREFIX}${a} ${b} ${c}`
}

// Value written to the form model: spaced number without placeholders, '' when nothing is typed
export function toModel(digits) {
  return digits ? `${PHONE_PREFIX}${groupDigits(digits).filter(Boolean).join(' ')}` : ''
}

// Caret index in the mask right after the k-th digit (k = 0 → right after the fixed prefix)
export const caretAfterDigits = k => (k === 0 ? PHONE_PREFIX.length : PHONE_PREFIX.length + k + Math.floor((k - 1) / 3))



// WEBPACK FOOTER //
// ./src/utils/phone.js